import store from '@/store';
import {Can} from '../../permission/ability';
import {RIGHTS} from '@/views/roles/rights';

export const BLANK_MODE_LOCK = 'preventMoving';

export function mayUseBlankMode() {
  return Boolean(store.state.users.me) && Can(RIGHTS.CANDIDATE_ADD);
}

export function shouldResumeBlankMode() {
  return localStorage.getItem(BLANK_MODE_LOCK) === 'true' && mayUseBlankMode();
}

export function keepBlankModeToStaff(to, from, next) {
  if (mayUseBlankMode()) {
    next();
    return;
  }

  next({name: 'home'});
}
